/** Formatos aceitos no carrossel (espelha backend carouselMedia.ts). */
export const CAROUSEL_MEDIA_ACCEPT =
  '.mp4,.webm,.png,.jpg,.jpeg,.webp,.gif,video/mp4,video/webm,image/png,image/jpeg,image/webp,image/gif';

const ALLOWED_EXT = ['.mp4', '.webm', '.png', '.jpg', '.jpeg', '.webp', '.gif'];

export function isAllowedCarouselFile(file: File): boolean {
  const name = file.name.toLowerCase();
  const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')) : '';
  if (!ALLOWED_EXT.includes(ext)) return false;
  const mt = (file.type || '').toLowerCase();
  if (!mt) return true;
  if (ext === '.mp4') return mt === 'video/mp4' || mt === 'application/octet-stream';
  if (ext === '.webm') return mt === 'video/webm' || mt === 'application/octet-stream';
  if (ext === '.gif') return mt === 'image/gif' || mt === 'application/octet-stream';
  if (ext === '.webp') return mt === 'image/webp' || mt === 'application/octet-stream';
  return mt.startsWith('image/') || mt === 'application/octet-stream';
}

export function isCarouselImageFilename(name: string): boolean {
  const ext = name.toLowerCase().slice(name.lastIndexOf('.'));
  return ['.png', '.jpg', '.jpeg', '.webp', '.gif'].includes(ext);
}
